import React, { useState } from "react";
import styles from "./PartnerForm.module.css";
import emailjs from "emailjs-com";

const PartnerForm = () => {
  const [formData, setFormData] = useState({
    instituteName: "",
    instituteAddress: "",
    applicableLaw: "",
    agreementDuration: "",
    instituteSignatoryName: "",
    instituteSignatoryDesignation: "",
    instituteSignatorySignature: "",
    instituteDate: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isChecked, setIsChecked] = useState(false); // Checkbox state
  const [errors, setErrors] = useState({});
  const [popupVisible, setPopupVisible] = useState(false);
  const [pdfBase64, setPdfBase64] = useState("");

  const exportPopupToPDF = () => {
    // Get input values dynamically
    const instituteName = document.querySelector(
      'input[name="instituteName"]'
    ).value;
    const instituteAddress = document.querySelector(
      'input[name="instituteAddress"]'
    ).value;
    const collegeSignatory = document.querySelector(
      'input[name="collegeSignatory"]'
    ).value;
    const collegeDesignation = document.querySelector(
      'input[name="collegeDesignation"]'
    ).value;

    const collegeDate = document.querySelector(
      'input[name="collegeDate"]'
    ).value;

    // Get the user-inputted date for the agreement
    const agreementDate = document.querySelector('input[name="day"]').value;

    // Build the agreement text dynamically
    const agreementText = `
      AGREEMENT FOR CSR INTERNSHIP AND EMPLOYMENT PROGRAM
  
      Aggre ment Date = ${agreementDate} 
      Institute Name = ${instituteName}
      Institute Address = ${instituteAddress} 
  
    
      For Training Institute/College:
      - **Authorized Signatory:** ${collegeSignatory}
      - **Designation:** ${collegeDesignation}
      - **Date:** ${collegeDate}
    `;

    // Update the state with the agreement text
    setPdfBase64(agreementText); // Send this as the pdfText in emailParams
    setIsChecked(true);

    // Close the popup after generating the agreement
    setIsPopupVisible(false);
  };

  const isPopupFormValid = () => {
    const inputs = document.querySelectorAll("popupInput");
    return Array.from(inputs).every((input) => input.value.trim() !== "");
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckboxChange = () => {
    if (!isChecked) {
      setIsPopupVisible(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submit");

    // Validate form before proceeding
    let newErrors = {};

    if (!formData.industryType)
      newErrors.industryType = "Industry Type is required.";
    if (!formData.organizationName)
      newErrors.organizationName = "Organization Name is required.";
    if (!formData.contactNumber)
      newErrors.contactNumber = "Contact Number is required.";
    if (!formData.email) newErrors.email = "Email is required.";
    if (!formData.state) newErrors.state = "State is required.";
    if (!formData.city) newErrors.city = "City is required."; // Corrected this line
    if (!isChecked) newErrors.isChecked = "You must agree to the terms.";

    // Set errors state
    setErrors(newErrors);
    setIsChecked(false);

    // Stop submission if errors exist
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    setIsSubmitting(true);

    const emailParams = {
      to_name: formData.organizationName,
      industryType: formData.industryType,
      organizationName: formData.organizationName,
      contactNumber: formData.contactNumber,
      email: formData.email,
      state: formData.state,
      city: formData.city,
      isInterested: isChecked ? "Yes" : "No",
      agreement: pdfBase64, // This is now the agreement text
    };

    emailjs
      .send(
        "service_2q1ttri",
        "template_43zrdhj",
        emailParams,
        "DSM_rBgDSF3ME5HHz"
      )
      .then(() => {
        setPopupMessage(
          "Thank you! Please check your email for further updates."
        );
        setIsSubmitting(false);
        setFormData({
          industryType: "",
          organizationName: "",
          contactNumber: "",
          email: "",
          state: "",
          city: "",
        });
        setErrors({});
      })
      .catch(() => {
        setPopupMessage("Failed to submit the form. Please try again.");
        setIsPopupVisible(true);
        setIsSubmitting(false);
      });
  };

  return (
    <div id="partnerForm" className={styles.formContainer}>
      <h1 className={styles.formTitle}>Partner with HR Labs</h1>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="industryType">
            Industry Type
          </label>
          <select
            id="industryType"
            name="industryType"
            className={styles.select}
            value={formData.industryType}
            onChange={handleChange}
          >
            <option value="">Select Industry Type</option>
            <option value="training_institute">Training Institute</option>
            <option value="college">College</option>
            <option value="consultancy">Consultancy</option>
          </select>
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="organizationName">
            Organization
          </label>
          <input
            id="organizationName"
            name="organizationName"
            type="text"
            className={styles.input}
            value={formData.organizationName}
            onChange={handleChange}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="contactNumber">
            Contact Number
          </label>
          <input
            id="contactNumber"
            name="contactNumber"
            type="tel"
            className={styles.input}
            value={formData.contactNumber}
            onChange={handleChange}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="email">
            Email
          </label>
          <input
            id="email"
            name="email"
            type="email"
            className={styles.input}
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="state">
            State
          </label>
          <input
            id="state"
            name="state"
            type="text"
            className={styles.input}
            value={formData.state}
            onChange={handleChange}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label} htmlFor="city">
            City
          </label>
          <input
            id="city"
            name="city"
            type="text"
            className={styles.input}
            value={formData.city}
            onChange={handleChange}
          />
        </div>

        {/* Conditionally render agreement form when checkbox is checked */}
        {isPopupVisible && (
          <section className={styles.overlay} id="popup-content">
            <article className={styles.popupContent}>
              <button
                className={styles.closeButton}
                onClick={() => setIsPopupVisible(false)}
              >
                ✖
              </button>

              <h3>
                <h2>AGREEMENT FOR CSR INTERNSHIP AND EMPLOYMENT PROGRAM</h2>
              </h3>

              <p>
                <h6>
                  This Agreement is made and entered into on this date
                  <input type="date" name="day" placeholder="day" required /> by
                  and between :
                </h6>
                <strong>HR Labs</strong>, a company under the laws of Karnataka,
                India, having its principal office at #2, 4th B Main,
                Kalyanagar, Vijaynagar Extn, Bangalore 560072 (hereinafter
                referred to as "Institute/College/Consultancy"),
                <h3>AND</h3>
                <input
                  type="text"
                  name="instituteName"
                  placeholder="Institute/College Name"
                  value={formData.instituteName}
                  onChange={handleChange}
                  required
                  className={styles.popupInput}
                />
                , a registered educational institution having its principal
                office at{" "}
                <input
                  type="text"
                  name="instituteAddress"
                  placeholder="Institute/College Address"
                  value={formData.instituteAddress}
                  onChange={handleChange}
                  required
                  className={styles.popupInput}
                />
                (hereinafter referred to as "Institute"),
              </p>
              <p>
                <strong>1. OBJECTIVE OF THE AGREEMENT </strong>
                The purpose of this Agreement is to establish a mutually
                beneficial relationship between the Company and the Institute to
                provide students with real-world industry exposure through the
                Company’s CSR Internship and Employment Program.
              </p>
              <p>
                <ul>
                  <li>
                    <strong>2. SCOPE OF THE PROGRAM</strong>
                    The Company agrees to provide students of the Institute with
                    the following benefits: <br />
                    <strong> (a) Real-World Experience:</strong> Students will
                    work on actual business challenges and projects under the
                    guidance of industry experts.
                    <br />
                  </li>
                  <li>
                    <strong> (b) Internship Certificate:</strong> Upon
                    successful completion of a 4-6 month unpaid internship,
                    students will receive an Internship Completion Certificate.
                  </li>
                  <li>
                    <strong>
                      {" "}
                      (c) Seamless Transition to Paid Roles : <br />
                    </strong>
                    <ol>
                      <li>
                        After 4 months of the internship, students will be moved
                        to a Trainee role with a stipend for the next 4 months.
                      </li>
                      <li>
                        Upon successful completion and qualification, students
                        will be promoted to Junior Engineer positions with a
                        competitive salary.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <strong>(d) Flexible Work-from-Home Opportunity:</strong>{" "}
                    Hybrid work model for balance between learning and
                    professional growth.
                  </li>
                  <li>
                    <strong>(e) Market-Driven Skills Development:</strong>{" "}
                    <ol>
                      <li>
                        Students will gain hands-on experience with
                        industry-relevant tools, frameworks, and methodologies
                        based on their assigned roles.
                      </li>
                      <li>
                        This will help them develop skills that employers
                        demand, making them job-ready upon completion.
                      </li>
                    </ol>
                  </li>
                </ul>
              </p>

              <p>
                <strong>3. STUDENT AGREEMENT REQUIREMENTS </strong>Each
                participating student will be required to sign an individual
                agreement committing to a 12-month tenure, including:
                <ol>
                  <li>Internship (4-6 months, unpaid)</li>
                  <li>Trainee Role (4 months, stipend-based)</li>
                  <li>
                    Junior Engineer Role (full-time employment with a
                    competitive salary)
                  </li>
                </ol>
              </p>
              <p>
                <strong>
                  4. RESPONSIBILITIES OF THE PARTIES <br />
                </strong>
                <strong>(a) Company Responsibilities: </strong>

                <ol>
                  <li>
                    Provide structured learning, mentorship, and assessment.
                  </li>
                  <li>Expose students to real-world projects.</li>
                  <li>Issue internship and employment certificates.</li>
                </ol>
              </p>
              <p>
                <strong> (b) Institute Responsibilities:</strong>
                <ol>
                  <li>Provide a pool of eligible students.</li>
                  <li>
                    Support students in work-from-office, home, or hybrid
                    models.
                  </li>
                  <li>Encourage students to fulfill their commitment.</li>
                </ol>
              </p>
              <p>
                <strong>5. TERMINATION & WITHDRAWAL</strong>
                (a) The Company reserves the right to terminate a student’s
                participation in case of non-performance, misconduct, or breach
                of agreement.
                <br />
                (b) The student or Institute may request withdrawal from the
                program, subject to a review by the Company.
              </p>
              <p>
                <strong>6. GENERAL TERMS</strong>
                (a) This Agreement shall be valid for a period of 3 years from
                the effective date. (b) Any disputes arising out of this
                Agreement shall be resolved amicably through discussions. If
                unresolved, they shall be subject to the jurisdiction of
                Bangalore, Karnataka. (c) This Agreement may only be amended in
                writing and signed by both parties.
              </p>

              <p>
                IN WITNESS WHEREOF, the parties hereto have executed this
                Agreement as of the date first above written.
              </p>

              <div className="footer-form">
                <p>
                  <strong>For HR Labs</strong>
                </p>
                <p>
                  Authorized Signatory: _______________ <br />
                  Designation: _______________ <br />
                  Date:
                  <input
                    type="date"
                    name="date"
                    className={styles.popupInput}
                  />
                </p>
                <h4>
                  For
                  <input
                    type="text"
                    name="instituteName"
                    placeholder="Institute/College Name"
                    value={formData.instituteName}
                    onChange={handleChange}
                    required
                    className={styles.popupInput}
                  />
                </h4>
                <p className="footer-heading">
                  Designation:
                  <input
                    type="text"
                    name="collegeDesignation"
                    placeholder="Designation"
                    className={styles.popupInput}
                  />
                  <br />
                  Signature:
                  <input
                    type="text"
                    name="collegeSignatory"
                    placeholder="Signature"
                    className={styles.popupInput}
                  />
                  <br />
                  Date:
                  <input
                    type="date"
                    name="collegeDate"
                    className={styles.popupInput}
                  />
                </p>

                <button
                  className={styles.generateSubmit}
                  onClick={exportPopupToPDF}
                  disabled={!isPopupFormValid()}
                >
                  Generate Agreement
                </button>
              </div>
            </article>
          </section>
        )}

        {popupVisible && (
          <div className={styles.popupOverlay}>
            <div className={styles.popupMessage}>
              <p>{popupMessage}</p>
              <button onClick={() => setPopupVisible(false)}>OK</button>
            </div>
          </div>
        )}

        <div className={styles.buttonWrapper}>
          {/* Checkbox for Agreement */}
          <div className={styles.formCheckbox}>
            <input
              type="checkbox"
              id="csrAgreement"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="csrAgreement" className={styles.label}>
              I agree to CSR Internship and employment program terms{" "}
            </label>

            {errors.organizationName && (
              <p className={styles.error}>{errors.organizationName}</p>
            )}
            {errors.contactNumber && (
              <p className={styles.error}>{errors.contactNumber}</p>
            )}
            {errors.email && <p className={styles.error}>{errors.email}</p>}
            {errors.state && <p className={styles.error}>{errors.state}</p>}
            {errors.city && <p className={styles.error}>{errors.city}</p>}
            {errors.isChecked && (
              <p className={styles.error}>{errors.isChecked}</p>
            )}
          </div>
          <button type="submit" className={styles.submitButton}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PartnerForm;
